<template>
	<section>
		<!-- 编辑商品信息弹出框 -->
		<el-dialog
			:title="$t('productEdit.editProductInformation')"
			:visible.sync="editProductDialogFormVisible"
			width="40%"
			:close-on-click-modal="false"
			:before-close="handleCloseEditProduct"
		>
			<div style="max-height: 500px; overflow: auto; padding: 0 15px">
				<el-form ref="editProductDialogForm" :model="editProductDialogForm">
					<h3>{{ $t("productEdit.basicInformation") }}</h3>
					<el-form-item :title="$t('productEdit.productName')" prop="name">
						<el-input v-model="editProductDialogForm.name" :disabled="true"></el-input>
					</el-form-item>
					<el-form-item :title="$t('productEdit.productAlias')" prop="alias">
						<el-input v-model="editProductDialogForm.alias" clearable></el-input>
					</el-form-item>
					<el-form-item :title="$t('productEdit.category')" prop="categoryName">
						<el-input v-model="editProductDialogForm.categoryName" :disabled="true"></el-input>
					</el-form-item>
					<el-form-item :title="$t('productEdit.state')" prop="status">
						<el-radio-group v-model="editProductDialogForm.status">
							<el-radio :label="1">{{ $t("productEdit.enable") }}</el-radio>
							<el-radio :label="0">{{ $t("productEdit.disable") }}</el-radio>
						</el-radio-group>
					</el-form-item>
					<div class="attribute-title">
						<h3>{{ $t("productEdit.specificationInformation") }}</h3>
						<div>
							<el-button type="primary" @click="selectAttributeDialogFormVisible = true" size="small">{{
								$t("productEdit.selectSpecifications")
							}}</el-button>
						</div>
					</div>
					<el-form-item v-for="item in filterAttribute" :label="item.name" :key="item.id" style="margin-bottom: 0 !important">
						<div style="display: flex; justify-content: space-between">
							<el-checkbox-group v-model="editProductDialogForm.attributeOptions">
								<el-checkbox v-for="element in item.options" :label="element.id" :key="element.id">{{ element.name }}</el-checkbox>
							</el-checkbox-group>
							<div v-if="item.name !== 'Units'">
								<el-button size="mini" plain type="danger" @click="handleDeleteAttribute(item)">{{
									$t("productEdit.deleteSpecification")
								}}</el-button>
							</div>
						</div>
					</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click="handleCloseEditProduct()">{{ $t("common.cancel") }}</el-button>
					<el-button type="primary" @click="handleEditProductSubmit()">{{ $t("common.confirm") }}</el-button>
				</div>
			</div>
		</el-dialog>

		<!-- 选择规格弹出框 -->
		<el-dialog :title="$t('productEdit.selectSpecifications')" :visible.sync="selectAttributeDialogFormVisible" width="40%" :close-on-click-modal="false">
			<div class="add-attribute-box">
				<el-input style="width: 200px" clearable v-model="keyword" size="mini" :placeholder="$t('productEdit.enterSpecificationName')"></el-input>
				<el-button type="primary" size="small" @click="handleAddDialogForm()">{{ $t("productEdit.addSpecs") }}</el-button>
			</div>
			<el-table ref="selectAttributeTable" :data="filterSpecification" style="width: 100%" :show-header="false" height="500">
				<el-table-column type="expand">
					<template slot-scope="scope"
						><div class="tag-box">
							<el-tag class="tag" v-for="item in scope.row.options" :key="item.id">{{ item.name }}</el-tag>
						</div>
					</template>
				</el-table-column>
				<el-table-column>
					<template slot-scope="scope">
						<el-checkbox :label="scope.row.id" v-model="editProductDialogForm.selectedAttributes">{{ scope.name }}</el-checkbox>
						<span>{{ scope.row.name }}</span>
					</template>
				</el-table-column>
                <el-table-column prop="cz" :label="$t('productSpecification.operate')" align="right">
                    <template slot-scope="scope" v-if="scope.row.name !== 'Units'">
                        <el-button size="mini" @click="handleEditDialogForm(scope.$index, scope.row)">{{ $t("productSpecification.edit") }}</el-button>
                        <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">{{ $t("common.delete") }}</el-button>
                    </template>
			    </el-table-column>
			</el-table>
			<div slot="footer" class="dialog-footer">
				<el-button @click="selectAttributeDialogFormVisible = false">{{ $t("common.cancel") }}</el-button>
				<el-button @click="selectAttributeDialogFormVisible = false" type="primary">{{ $t("common.confirm") }}</el-button>
			</div>
		</el-dialog>

		<!-- 添加规格弹出框 -->
		<AddSpecification
			:addDialogFormVisible="addDialogFormVisible"
			@handle-add-cancel="handleAddCancel"
			@handle-update-specification="handleUpdateSpecification"
		></AddSpecification>

        <!--编辑规格弹出框-->
		<el-dialog :title="$t('productSpecification.editSpecifications')" :visible.sync="editDialogFormVisible" width="30%" :close-on-click-modal="false">
			<el-form ref="editDialogForm" :rules="formRules" :model="editDialogForm">
				<el-form-item :label="$t('productSpecification.specificationName')" prop="name">
					<el-input v-model="editDialogForm.name" :disabled="true"></el-input>
				</el-form-item>
				<el-form-item :label="$t('productSpecification.attributes')" prop="options">
					<div class="table-caption">
						<el-button size="mini" type="primary" @click="handleEditAddOptions()">{{ $t("productSpecification.addTo") }}</el-button>
					</div>
					<el-table style="width: 100%" :data="this.editDialogForm.options" :empty-text="$t('productSpecification.addAttributes')" size="mini">
						<el-table-column prop="name" :label="$t('productSpecification.name')"> </el-table-column>
						<el-table-column prop="actions" :label="$t('productSpecification.operate')">
							<template slot-scope="scope">
								<el-button size="mini" type="danger" @click="handleEditDeleteOptions(scope.$index)">{{ $t("common.delete") }}</el-button>
							</template>
						</el-table-column>
					</el-table>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="handleEditCancel()">{{ $t("common.cancel") }}</el-button>
				<el-button type="primary" @click="handleEditConfirm()">{{ $t("common.sure") }}</el-button>
			</span>
		</el-dialog>

        <!-- 编辑添加规格options弹出框 -->
		<el-dialog :title="$t('common.options')" :visible.sync="editAddOptionsFormVisible" width="30%" :close-on-click-modal="false">
			<p>{{ $t("common.option") }}</p>
			<el-input v-model="editOptionsName" :placeholder="$t('productSpecification.optionName')" clearable></el-input>
			<span slot="footer" class="dialog-footer">
				<el-button @click="handleEditAddOptionsCancel()">{{ $t("common.cancel") }}</el-button>
				<el-button type="primary" @click="handleEditAddOptionsConfirm()">{{ $t("common.sure") }}</el-button>
			</span>
		</el-dialog>
	</section>
</template>
<script>
import AddSpecification from "./add-specification.vue";
import {
	getCustomerAttributesDetails,
    deleteCustomerAttributes,
    putCustomerAttributesUpdate,
} from "@/services/api-v2/api-v2";

export default {
	components: {
		AddSpecification,
	},
	props: {
		// 所有规格
		attributeOptions: {
			type: Array,
			required: true,
			default: [],
		},

		// 编辑商品弹出框
		editProductDialogFormVisible: {
			type: Boolean,
			required: true,
			default: false,
		},

		//编辑商品数据
		editProductDialogForm: {
			type: Object,
			required: true,
			default: {},
		},
	},
	data() {
		return {
			// 选择属性弹出框
			selectAttributeDialogFormVisible: false,

			// 添加规格弹出框
			addDialogFormVisible: false,

			// 搜索规格关键词
			keyword: "",
            // 规格编辑弹出框
            editDialogFormVisible: false,

            // 编辑添加规格options名称
			editOptionsName: "",

            // 规格编辑时表单值
            editDialogForm: {
                name: "",
                id: "",
                options: [],
                index: "",
            },
            // 规格表单验证
            formRules: {
                name: [
                    {
                        required: true,
                        message: this.$t(
                            "productSpecification.enterSpecificationName"
                        ),
                        trigger: "blur",
                    },
                ],
                options: [
                    {
                        required: true,
                        message: this.$t(
                            "productSpecification.addOptions"
                        ),
                        trigger: "blur",
                    },
                ],
            },
            // 编辑添加options弹出框
			editAddOptionsFormVisible: false,
		};
	},
	computed: {
		filterAttribute() {
			return this.attributeOptions.filter((item) => {
				if (this.editProductDialogForm.selectedAttributes.includes(item.id)) {
					return item;
				}
			});
		},

		filterSpecification() {
			if (this.keyword) {
				const upperCaseKeyword = this.keyword.toUpperCase();
				const filteredData = this.attributeOptions.filter((item) => {
					return (
						item.name.toUpperCase().includes(upperCaseKeyword) || item.options.some((item) => item.name.toUpperCase().includes(upperCaseKeyword))
					);
				});
				return filteredData;
			}
			return this.attributeOptions;
		},
	},
	methods: {
		// 关闭编辑弹出框
		handleCloseEditProduct() {
			this.$emit("handle-close-edit-product");
		},

		// 删除编辑选中规格
		handleDeleteAttribute(selectAttribut) {
			selectAttribut.options.forEach((item) => {
				const index = this.editProductDialogForm.attributeOptions.findIndex((element) => element === item.id);
				if (index !== -1) {
					this.editProductDialogForm.attributeOptions.splice(index, 1);
				}
			});
			this.filterAttribute.forEach((item, index) => {
				if (item.id === selectAttribut.id) {
					this.filterAttribute.splice(index, 1);
				}
			});
			this.editProductDialogForm.selectedAttributes.forEach((item, index) => {
				if (item === selectAttribut.id) {
					this.editProductDialogForm.selectedAttributes.splice(index, 1);
				}
			});
		},

		//确定商品信息
		handleEditProductSubmit() {
			const isAllExist = this.filterAttribute.every((item) => {
				const isExist = item.options.some((option) => this.editProductDialogForm.attributeOptions.includes(option.id));

				if (!isExist) {
					this.$message.error(this.$t("productEdit.pleaseChoose") + item.name + this.$t("productEdit.attributes"));
				}

				return isExist;
			});

			if (isAllExist) {
				this.$emit("handle-confirm-product-edit", this.editProductDialogForm);
				this.handleCloseEditProduct();
			}
		},

		// 点击添加规格弹出框
		handleAddDialogForm() {
			this.addDialogFormVisible = true;
		},

		// 取消添加
		handleAddCancel() {
			this.addDialogFormVisible = false; // 关闭添加表单窗口
		},

		//确定添加更新规格列表
		handleUpdateSpecification() {
			this.$emit("handle-update-specification");
		},

         // 编辑规格
		async handleEditDialogForm(index, row) {
			try {
				const { data } = await getCustomerAttributesDetails(this.$route.params.id, row.id);
				this.editDialogForm.name = data.name;
				this.editDialogForm.id = data.id;
				this.editDialogForm.options = data.options;
				this.editDialogForm.index = index;
				this.editDialogFormVisible = true;
			} catch (error) {
				this.$message.error(error); // 弹出错误提示
			}
		},
        // 删除规格
		async handleDelete(index, row) {
			const result = await this.$confirm(this.$t("productSpecification.sureDelete"), this.$t("productSpecification.hint"), {
				confirmButtonText: this.$t("common.sure"),
				cancelButtonText: this.$t("common.cancel"),
				type: "warning",
			});
			if (result == "confirm") {
				try {
					await deleteCustomerAttributes(this.$route.params.id, row.id);
					this.attributeOptions.splice(index, 1);
					this.$message.success(this.$t("productSpecification.successfullyDeleted")); // 弹出成功提示
				} catch (error) {
					this.$message.error(error); // 弹出错误提示
				}
			}
		},
        // 编辑确定编辑
		async handleEditConfirm() {
			this.$refs.editDialogForm.validate(async (valid) => {
				if (valid) {
					try {
						await putCustomerAttributesUpdate(this.$route.params.id, this.editDialogForm.id, this.editDialogForm);
						this.attributeOptions[this.editDialogForm.index].name = this.editDialogForm.name;
						this.$message.success(this.$t("productSpecification.editedSuccessfully")); // 弹出成功提示
						this.editDialogFormVisible = false;
					} catch (error) {
						this.$message.error(error); // 弹出错误提示
					}
				} else {
					this.$message.error(this.$t("productSpecification.errorMessage")); // 弹出错误提示
					return false;
				}
			});
		},
        // 取消编辑
		handleEditCancel() {
			this.editDialogFormVisible = false;
		},
         // 编辑添加options弹出框
		handleEditAddOptions() {
			this.editAddOptionsFormVisible = true;
		},

          // 编辑删除options
		handleEditDeleteOptions(index) {
			this.editDialogForm.options.splice(index, 1);
		},

        // 编辑取消添加options
		handleEditAddOptionsCancel() {
			this.editAddOptionsFormVisible = false;
			this.editOptionsName = "";
		},

        // 编辑确定添加options
		handleEditAddOptionsConfirm() {
			if (!this.editOptionsName) {
				this.$message.error(this.$t("productSpecification.enterAttributeName"));
				return;
			}
			this.editDialogForm.options.push({ name: this.editOptionsName });
			this.editOptionsName = "";
			this.editAddOptionsFormVisible = false;
		},
	},
};
</script>
<style scoped>
.dialog-footer {
	display: flex;
	justify-content: flex-end;
	margin-top: 30px;
}
.select-attribute-box {
	max-height: 500px;
	min-height: 500px;
	overflow: auto;
}
.select-attribute-group {
	margin-top: 15px;
}
.attribute-title {
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.tag-box {
	margin-top: -12px;
}
.tag {
	margin-top: 12px;
	margin-left: 15px;
}
.add-attribute-box {
	display: flex;
	justify-content: space-between;
	margin-bottom: 15px;
}
</style>
